'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var colors$1 = require('@material-ui/core/colors');

var colors = {
  amber: colors$1.amber,
  blue: colors$1.blue,
  blueGrey: colors$1.blueGrey,
  brown: colors$1.brown,
  common: colors$1.common,
  cyan: colors$1.cyan,
  deepOrange: colors$1.deepOrange,
  deepPurple: colors$1.deepPurple,
  green: colors$1.green,
  grey: colors$1.grey,
  indigo: colors$1.indigo,
  lightBlue: colors$1.lightBlue,
  lightGreen: colors$1.lightGreen,
  lime: colors$1.lime,
  orange: colors$1.orange,
  pink: colors$1.pink,
  purple: colors$1.purple,
  red: colors$1.red,
  teal: colors$1.teal,
  yellow: colors$1.yellow
};
var colorsMain = [colors.red[500], colors.pink[500], colors.purple[500], colors.deepPurple[500], colors.indigo[500], colors.blue[500], colors.lightBlue[500], colors.cyan[500], colors.teal[500], colors.green[500], colors.lightGreen[500], colors.lime[500], colors.amber[500], colors.yellow[500], colors.orange[500], colors.deepOrange[500], colors.brown[500], colors.blueGrey[500]];
var colorsLight = [colors.red[200], colors.pink[200], colors.purple[200], colors.deepPurple[200], colors.indigo[200], colors.blue[200], colors.lightBlue[200], colors.cyan[200], colors.teal[200], colors.green[200], colors.lightGreen[200], colors.lime[200], colors.amber[200], colors.yellow[200], colors.orange[200], colors.deepOrange[200], colors.brown[200], colors.blueGrey[200]];

exports.colors = colors;
exports.colorsLight = colorsLight;
exports.colorsMain = colorsMain;
